export default {
      id: "switching-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#switching",
      toString: function () {
        return this.url;
      }
    }